import lodash from 'lodash'
import React, { ReactElement, useEffect, useMemo } from 'react'

import {
  useField,
  useFieldContext,
} from '../../../../../../1stlog-ui/src/components/Field'
import Points from './Points'
import TransportCategoryCombination from './TransportCategoryCombination'

const HazmatShipmentValidation = (): ReactElement => {
  const colis = useField('colis', { ignorePrefix: true })

  const hazmats = useMemo(
    () =>
      lodash
        .flatten(
          lodash.map(colis, (coli) => {
            const ggs = lodash.find(
              lodash.get(coli, 'services'),
              (s) => s.name === 'GGS',
            )
            return lodash.get(lodash.first(lodash.get(ggs, 'values')), 'value')
          }),
        )
        .filter(Boolean),
    [colis],
  )

  // punkte
  //
  const { prefix } = useFieldContext()

  // console.log("colis", colis)

  useEffect(() => {}, [colis])

  return (
    <>
      <Points hazmats={hazmats} />
      <TransportCategoryCombination hazmats={hazmats} />
    </>
  )

  // return (
  //   <>
  //     <div>
  //       <code>prefix: {prefix}</code>
  //     </div>
  //     {/* {isLimitedQuantityInvalid && (
  //       <FormRow>
  //         <Col>
  //           <Feedback meta={meta} />
  //         </Col>
  //       </FormRow>
  //     )} */}
  //   </>
  // )
}

export default HazmatShipmentValidation
